/**
 * SaraivaCnpjDisponivel
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {SaraivaCnpjDisponivelCollection} from '@/model/collection/SaraivaCnpjDisponivelCollection'

/* TODO: review generated class */
export class SaraivaCnpjDisponivel extends Resource {
  id: number = 0

  /**
   * DEVERÁ SER APAGADA PÓS MIGRAÇÃO SARAIVA!!!
   */
  cnpjRaiz: string | null = null

  get $id() {
    return this.id
  }
  set $id(val) {
    this.id = val
  }

  /**
   * Gets a instance of a given ID of SaraivaCnpjDisponivel
   */
  async getSaraivaCnpjDisponivel(id: number) {
    return await Request.get(`/admin/saraiva-cnpj-disponivel/${id}`)
      .name('getSaraivaCnpjDisponivel')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of SaraivaCnpjDisponivel
   */
  static async listSaraivaCnpjDisponivel(params: any) {
    return await Request.get(`/admin/saraiva-cnpj-disponivel`, {params})
      .name('listSaraivaCnpjDisponivel')
      .as(SaraivaCnpjDisponivelCollection)
      .getData()
  }

  /**
   * Persists a new instance of SaraivaCnpjDisponivel. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistSaraivaCnpjDisponivel() {
    return await Request.post(`/admin/saraiva-cnpj-disponivel`, this)
      .name('persistSaraivaCnpjDisponivel')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of SaraivaCnpjDisponivel to use it in a CSV file
   */
  static async listCsvSaraivaCnpjDisponivel(params: any) {
    return await Request.get(`/admin/saraiva-cnpj-disponivel/csv`, {params})
      .name('listCsvSaraivaCnpjDisponivel')
      .as(SaraivaCnpjDisponivelCollection)
      .getData()
  }
}
